import classnames from 'classnames';
import React, { memo } from 'react';

interface Props {
  className?: string;
}

export const ShimmerLoading = memo(({ className }: Props) => (
  <div
    className={classnames(
      'min-h-3 animate-pulse rounded bg-neutral',
      className,
    )}
  />
));
